<template>
    <Layout>
        <div slot="main" class="home-bg">
            <nav class="back-nav">
                <div class="center">
                    <div class="strong">{{lang.about}} -- {{lang.recruit}}</div>
                    <div class="back-icon" @click="goBack">
                        <img :src="back" alt="">
                    </div>
                </div>
            </nav>
            <div class="jd-block">
                <div class="center">
                    <small></small>
                    <div class="title-line">
                        <p><span>{{lang.recruitPost}}：</span><strong>{{isCn?detail.cnJobName:detail.enJobName}}</strong></p>
                        <p><small>{{lang.hrMail}}：</small>{{hrEmail}}</p>
                    </div>
                    <div class="item-line">
                        <p><small>{{lang.recruitAddress}}：</small><span>{{isCn?detail.cnWorkplace:detail.enWorkplace}}</span></p>
                        <p><small>{{lang.recruitDegree}}：</small><span>{{isCn?detail.cnEducationRequirement:detail.enEducationRequirement}}</span></p>
                        <p><small>{{lang.recruitExp}}：</small><span>{{isCn?detail.cnWorkYears:detail.enWorkYears}}</span></p>
                        <p><small>{{lang.recruitSalary}}：</small><span>{{isCn?detail.cnSalaryRange:detail.enSalaryRange}}</span></p>
                    </div>
                    <h6><span>{{lang.recruitDuty}}：</span></h6>
                    <div class="text-area gen-editor" v-html="isCn?detail.cnJobDuty:detail.enJobDuty"></div>
                    <h6><span>{{lang.recruitContent}}：</span></h6>
                    <div class="text-area gen-editor" v-html="isCn?detail.cnJobContent:detail.enJobContent"></div>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import ajax from '@/utils/ajax';
import backSrc from '@/style/back.png';
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import router from '@/router';

export default {
    name: 'jd',
    components: {
        Layout,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            back: backSrc,
            lang: getLang(),
            hrEmail: '',
            detail: {},
        };
    },
    mounted() {
        const { id } = this.$route.query;
        ajax.get('/web/about_us/recruitment_detail.json', { id }).then((result) => {
            this.detail = result.data;
        }).catch(() => {});
        ajax.get('/web/about_us/hr_email.json').then((result) => {
            this.hrEmail = result.data;
        }).catch(() => {});
    },
    methods: {
        goBack() {
            router.go(-1);
        },
    },
};
</script>
<style lang="less" scoped>
    .home-bg {
        background: #F8FAF9;
    }
    .back-nav {
        width: 100%;
        height: 64px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-content: center;
        border-bottom: 8px solid #F8FAF9;
        .center {
            width: 960px;
            margin: 0 auto;
            position: relative;
        }
        .back-icon {
            width: 11px;
            height: 16px;
            margin-top: 24px;
            margin-left: 2px;
            z-index: 3;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .strong {
            position: absolute;
            top: 0;
            left: 32px;
            width: 100%;
            height: 100%;
            font-size: 16px;
            color: #4A4A4A;
            line-height: 64px;
            font-weight: 500;
        }
    }
    .jd-block {
        padding-top: 40px;
        background: #fff;
        .center {
            width: 960px;
            margin: 0 auto;
        }
        .title-line {
            display: flex;
            justify-content: space-between;
            p {
                line-height: 18px;
                color: #4A4A4A;
                font-weight: 400;
            }
            span {
                font-size: 14px;
                font-weight: 600;
            }
            small {
                font-size: 14px;
                color: #9B9B9B;
            }
            strong {
                font-weight: 600;
                color: #C71F4B;
                font-size: 18px;
            }
        }
        .item-line {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 16px 0;
            border-bottom: 1px solid #F1F1F1;
            margin-bottom: 15px;
            p {
                margin-right: 80px;
                height: 18px;
                line-height: 18px;
            }
            small {
                font-size: 14px;
                color: #9B9B9B;
            }
        }
        h6 {
            padding-bottom: 12px;
            span {
                font-size: 14px;
                font-weight: 600;
            }
        }
        .text-area {
            margin-bottom: 10px;
            padding: 12px 15px;
            background: #F1F1F1;
            color :#9B9B9B;
            font-size: 12px;
            &:last-child {
                margin-bottom: 24px;
            }
        }
    }
</style>
